import {
	formatHexColor,
	parseHexColor,
	type RgbChannelDelta,
} from "./sq-color-hex";
import type { SqColorGradientPair } from "./sq-color-types";

/** Calibrated on orange badge surfaces; adjust once in this file if needed. */
export const SQ_DARKEN_FROM_FACTOR = 0.847;

/** Orange static pair channel delta (reference for all dark theme pairs). */
export const SQ_ORANGE_REFERENCE_DELTA: RgbChannelDelta = {
	r: -69,
	g: -64,
	b: -43,
};

export function sqDeriveThemeDarkPair(
	lightPair: SqColorGradientPair,
	referenceDelta: RgbChannelDelta = SQ_ORANGE_REFERENCE_DELTA,
	darkenFromFactor: number = SQ_DARKEN_FROM_FACTOR,
): SqColorGradientPair {
	const lightFrom = parseHexColor(lightPair.from);
	const lightTo = parseHexColor(lightPair.to);

	const darkFromFloat = {
		r: lightFrom.r * darkenFromFactor,
		g: lightFrom.g * darkenFromFactor,
		b: lightFrom.b * darkenFromFactor,
	};

	const darkToFloat = {
		r: darkFromFloat.r + referenceDelta.r,
		g: darkFromFloat.g + referenceDelta.g,
		b: darkFromFloat.b + referenceDelta.b,
	};

	const wouldClamp =
		darkToFloat.r < 0 || darkToFloat.g < 0 || darkToFloat.b < 0;

	if (wouldClamp) {
		return {
			from: formatHexColor(
				darkFromFloat.r,
				darkFromFloat.g,
				darkFromFloat.b,
			),
			to: formatHexColor(
				lightTo.r * darkenFromFactor,
				lightTo.g * darkenFromFactor,
				lightTo.b * darkenFromFactor,
			),
		};
	}

	return {
		from: formatHexColor(darkFromFloat.r, darkFromFloat.g, darkFromFloat.b),
		to: formatHexColor(darkToFloat.r, darkToFloat.g, darkToFloat.b),
	};
}

export type { RgbChannelDelta };
